import React from "react";

/**
 * Modern minimalist section label — small accent bar + uppercase mono text.
 * Replaces the older "//" prefix pattern.
 *
 * Variants:
 *   default: orange bar + orange text
 *   muted:   steel bar + steel text
 */
export default function SectionLabel({
  children,
  variant = "default",
  className = "",
  testid,
}) {
  const barClass =
    variant === "muted" ? "bg-steel-light" : "bg-signal";
  const textClass =
    variant === "muted" ? "text-steel-light" : "text-signal";

  return (
    <div
      className={`inline-flex items-center gap-3 ${className}`}
      data-testid={testid}
    >
      <span
        aria-hidden="true"
        className={`inline-block w-8 h-[2px] ${barClass}`}
      />
      <span
        className={`font-mono text-xs tracking-[0.2em] uppercase ${textClass}`}
      >
        {children}
      </span>
    </div>
  );
}
